<template>
  <div class="animated fadeIn">
    <b-row class="mb-4">
      <b-col md="11">
        <div class="form-group form-actions float-left pb-2">
          <b-button
            :disabled="isGenerating"
            class="mr-2 btn"
            variant="success"
            type="submit"
            size="md"
            @click="refreshReport"
          >
            Generate Report
            <i
              v-show="seminar.is_seminars_loading"
              class="fa fa-refresh fa-spin localBold mr-2"
            ></i>
          </b-button>
        </div>
      </b-col>

      <b-col md="1">
        <span class="icon-small">
          <i
            class="fa fa-download fa-lg mt-3 pt-0 ml-0 clickIcon"
            style="color: #555;"
            @click="my_download"
          ></i>
        </span>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12">
        <b-table
          :items="calculatedStats"
          :fields="fields2"
          hover
          small
          fixed
          caption
          responsive="sm"
        ></b-table>
      </b-col>
    </b-row>
    <b-row></b-row>
    <b-row class="primary2-row divider-row">
      <b-col md="12" class="text-left"></b-col>
    </b-row>
    <b-row>
      <b-col sm="12">
        <b-table
          @row-clicked="myRowClickHandler"
          :items="filteredObjects"
          :fields="fields"
          hover
          small
          fixed
          caption
          selectable
          select-mode="single"
          responsive="sm"
          selectedVariant="success"
          :current-page="currentPage"
          :per-page="perPage"
        ></b-table>

        <nav v-show="isNavVisible">
          <b-pagination
            :per-page="perPage"
            :total-rows="totalRowsFiltered"
            v-model="currentPage"
            prev-text="Prev"
            next-text="Next"
            hide-goto-end-buttons
          />
        </nav>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import cTable from "@/views/base/Table.vue";
//import DeleteDialog from "@/components/dialogs/DeleteDialog.vue";
import StyledDialog from "@/components/dialogs/StyledModal.vue";
import moment from "moment";

export default {
  name: "SeminarList",
  data: () => {
    return {
      isGenerating: false,
      fields: [
        {
          key: "SeminarID",
          label: "ID",
          sortable: true
        },
        {
          key: "Seminar.Territory.TerritoryName",
          label: "Territory",
          sortable: true
        },

        {
          key: "Seating.DateOfSeating",
          label: "Seating Date",
          sortable: true
        },
        {
          key: "Seminar.Owner.UserName",
          label: "Account Manager",
          sortable: true
        },
        {
          key: "SeatingQuantity",
          label: "Quantity",
          sortable: true
        }
      ],
      fields2: [
        {
          key: "DayOfWeek",
          label: "Day",
          sortable: true
        },
        {
          key: "SeminarCount",
          label: "#Mailings",
          sortable: true
        },
        {
          key: "SeatingCount",
          label: "#Seminars",
          sortable: true
        },
        {
          key: "Quantity",
          label: "Qty",
          sortable: true
        },
        {
          key: "RSVP",
          label: "RSVP",
          sortable: true
        },
        {
          key: "Wait",
          label: "Wait",
          sortable: true
        },
        {
          key: "RSVPNoWebPer",
          label: "% RSVP no web",
          sortable: true
        },
        {
          key: "Web",
          label: "Web",
          sortable: true
        },
        {
          key: "RSVPPer",
          label: "% RSVP with Web",
          sortable: true
        }
        // ,

        //   key: "TotalQuantity",
        //   label: "Quantity",
        //   sortable: true,
        // },
        // {
        //   key: "TotalRSVPs",
        //   label: "RSVP",
        //   sortable: true,
        // },
      ],
      mySelected: { Territory: {}, Owner: {}, Restaurant: {} },
      currentPage: 1,
      perPage: 100,
      filteredObjects: [],
      calculatedStats: [],
      searchString: "",
      myMon: {},
      myTues: {},
      myWed: {},
      myThurs: {},
      myFri: {},
      mySat: {},
      mySun: {}
    };
  },
  components: {
    cTable,
    //DeleteDialog,
    StyledDialog
  },
  created() {
    this.filterList();
  },
  computed: {
    totalRows: function() {
      return this.$store.state.seminar.rsvp_comparators.length;
      //return 4;
    },
    totalObjects: function() {
      return this.$store.state.seminar.rsvp_comparators;
      //return 4;
    },
    totalRowsFiltered: function() {
      return this.filteredObjects.length;
    },
    isNavVisible: function() {
      return this.totalRowsFiltered > this.perPage;
    },
    ...mapState(["seminar", "globals", "notification", "n_user"]),
    ...mapActions("notification", ["add", "remove"])
  },
  updated() {
    this.incrementCount;
  },
  watch: {
    totalObjects(newValue, oldValue) {
      //this.filterList();
    },
    "$store.state.globals.default_from_date": function(newValue, oldValue) {},
    "$store.state.globals.default_to_date": function(newValue, oldValue) {},
    "$store.state.globals.default_pp"(newValue, oldValue) {
      //this.refreshReport();
    },
    "$store.state.globals.default_report_territory"(newValue, oldValue) {
      //this.refreshReport();
    },
    "$store.state.globals.default_report_vendor"(newValue, oldValue) {
      //this.refreshReport();
    },
    "$store.state.globals.default_report_mailer"(newValue, oldValue) {
      //this.refreshReport();
    },
    "$store.state.globals.default_report_artwork"(newValue, oldValue) {
      //this.refreshReport();
    },
    filteredObjects(newValue, oldValue) {
      this.calculate();
    }
  },
  methods: {
    async refreshReport() {
      this.isGenerating = true;
      var _op = {
        FromDate: this.$store.state.globals.default_from_date,
        ToDate: this.$store.state.globals.default_to_date,
        VendorID: this.$store.state.globals.default_report_vendor,
        OrderedBy: this.$store.state.globals.default_pp,
        TerritoryID: this.$store.state.globals.default_report_territory,
        MailerTypeID: this.$store.state.globals.default_report_mailer,
        ArtworkID: this.$store.state.globals.default_report_artwork
      };

      await this.$store.dispatch("seminar/fetchRsvpComparisonNew", _op);
      this.filterList();
    },

    my_download() {
      var _op = {
        FromDate: this.$store.state.globals.default_from_date,
        ToDate: this.$store.state.globals.default_to_date,
        VendorID: this.$store.state.globals.default_report_vendor,
        OrderedBy: this.$store.state.globals.default_pp,
        TerritoryID: this.$store.state.globals.default_report_territory,
        MailerTypeID: this.$store.state.globals.default_report_mailer,
        ArtworkID: this.$store.state.globals.default_report_artwork
      };
      //console.log(_op);

      this.$store
        .dispatch("seminar/DownloadRSVPReport", _op)
        .then(response =>
          window.open(
            "http://rm_api.revolutionterritorymanager.com/Output/" +
              response.data["FilteredRSVPReportDownloadResult"],
            "_blank"
          )
        );
    },
    calculate: function() {
      //this.calculatedStats.push({ SeminarCount: 1, SeatingCount: 2 });

      var myMon = {
        DayOfWeek: "Monday",
        SeminarCount: 0,
        SeatingCount: 0,
        Quantity: 0,
        RSVP: 0,
        Wait: 0,
        Web: 0,
        RSVPPer: 0.0,
        RSVPNoWebPer: 0.0
      };
      var myTues = {
        DayOfWeek: "Tuesday",
        SeminarCount: 0,
        SeatingCount: 0,
        Quantity: 0,
        RSVP: 0,
        Wait: 0,
        Web: 0,
        RSVPPer: 0.0,
        RSVPNoWebPer: 0.0
      };
      var myWed = {
        DayOfWeek: "Wednesday",
        SeminarCount: 0,
        SeatingCount: 0,
        Quantity: 0,
        RSVP: 0,
        Wait: 0,
        Web: 0,
        RSVPPer: 0.0,
        RSVPNoWebPer: 0.0
      };
      var myThurs = {
        DayOfWeek: "Thursday",
        SeminarCount: 0,
        SeatingCount: 0,
        Quantity: 0,
        RSVP: 0,
        Wait: 0,
        Web: 0,
        RSVPPer: 0.0,
        RSVPNoWebPer: 0.0
      };
      var myFri = {
        DayOfWeek: "Friday",
        SeminarCount: 0,
        SeatingCount: 0,
        Quantity: 0,
        RSVP: 0,
        Wait: 0,
        Web: 0,
        RSVPPer: 0.0,
        RSVPNoWebPer: 0.0
      };
      var mySat = {
        DayOfWeek: "Saturday",
        SeminarCount: 0,
        SeatingCount: 0,
        Quantity: 0,
        RSVP: 0,
        Wait: 0,
        Web: 0,
        RSVPPer: 0.0,
        RSVPNoWebPer: 0.0
      };
      var mySun = {
        DayOfWeek: "Sunday",
        SeminarCount: 0,
        SeatingCount: 0,
        Quantity: 0,
        RSVP: 0,
        Wait: 0,
        Web: 0,
        RSVPPer: 0.0,
        RSVPNoWebPer: 0.0
      };
      var myTotals = {
        DayOfWeek: "Totals",
        SeminarCount: 0,
        SeatingCount: 0,
        Quantity: 0,
        RSVP: 0,
        Wait: 0,
        Web: 0,
        RSVPPer: 0.0,
        RSVPNoWebPer: 0.0
      };
      var _ph = -1;
      var _phDOW = "";
      var _additive = 0;

      this.calculatedStats = [];

      this.filteredObjects.forEach(comp => {
        _additive = 0;
        if (comp.Seating.SeminarID !== _ph) {
          _additive = 1;
        } else {
          if (comp.Seating.DayOfWeek !== _phDOW) {
            _additive = 1;
          }
        }

        _ph = comp.Seating.SeminarID;
        _phDOW = comp.Seating.DayOfWeek;

        switch (comp.Seating.DayOfWeek) {
          case "Monday":
            myMon.SeatingCount++;
            myMon.SeminarCount += _additive;
            myMon.Quantity += comp.SeatingQuantity;
            myMon.RSVP += comp.Seating.AttendeeCount;
            myMon.Wait += comp.Seating.WaitListCount;
            myMon.Web += comp.Seating.WebCount;
            break;
          case "Tuesday":
            myTues.SeatingCount++;
            myTues.SeminarCount += _additive;
            myTues.Quantity += comp.SeatingQuantity;
            myTues.RSVP += comp.Seating.AttendeeCount;
            myTues.Wait += comp.Seating.WaitListCount;
            myTues.Web += comp.Seating.WebCount;
            break;
          case "Wednesday":
            myWed.SeatingCount++;
            myWed.SeminarCount += _additive;
            myWed.Quantity += comp.SeatingQuantity;
            myWed.RSVP += comp.Seating.AttendeeCount;
            myWed.Wait += comp.Seating.WaitListCount;
            myWed.Web += comp.Seating.WebCount;
            break;
          case "Thursday":
            myThurs.SeatingCount++;
            myThurs.SeminarCount += _additive;
            myThurs.Quantity += comp.SeatingQuantity;
            myThurs.RSVP += comp.Seating.AttendeeCount;
            myThurs.Wait += comp.Seating.WaitListCount;
            myThurs.Web += comp.Seating.WebCount;
            break;
          case "Friday":
            myFri.SeatingCount++;
            myFri.SeminarCount += _additive;
            myFri.Quantity += comp.SeatingQuantity;
            myFri.RSVP += comp.Seating.AttendeeCount;
            myFri.Wait += comp.Seating.WaitListCount;
            myFri.Web += comp.Seating.WebCount;
            break;
          case "Saturday":
            mySat.SeatingCount++;
            mySat.SeminarCount += _additive;
            mySat.Quantity += comp.SeatingQuantity;
            mySat.RSVP += comp.Seating.AttendeeCount;
            mySat.Wait += comp.Seating.WaitListCount;
            mySat.Web += comp.Seating.WebCount;
            break;
          case "Sunday":
            mySun.SeatingCount++;
            mySun.SeminarCount += _additive;
            mySun.Quantity += comp.SeatingQuantity;
            mySun.RSVP += comp.Seating.AttendeeCount;
            mySun.Wait += comp.Seating.WaitListCount;
            mySun.Web += comp.Seating.WebCount;
            break;
        }
      });

      if (myMon.Quantity > 0) {
        myMon.RSVPPer =
          (
            ((myMon.RSVP + myMon.Wait + myMon.Web) * 100) /
            myMon.Quantity
          ).toFixed(2) + "%";
        myMon.RSVPNoWebPer =
          (((myMon.RSVP + myMon.Wait) * 100) / myMon.Quantity).toFixed(2) + "%";
      }
      if (myTues.Quantity > 0) {
        myTues.RSVPPer =
          (
            ((myTues.RSVP + myTues.Wait + myTues.Web) * 100) /
            myTues.Quantity
          ).toFixed(2) + "%";
        myTues.RSVPNoWebPer =
          (((myTues.RSVP + myTues.Wait) * 100) / myTues.Quantity).toFixed(2) +
          "%";
      }
      if (myWed.Quantity > 0) {
        myWed.RSVPPer =
          (
            ((myWed.RSVP + myWed.Wait + myWed.Web) * 100) /
            myWed.Quantity
          ).toFixed(2) + "%";
        myWed.RSVPNoWebPer =
          (((myWed.RSVP + myWed.Wait) * 100) / myWed.Quantity).toFixed(2) + "%";
      }
      if (myThurs.Quantity > 0) {
        myThurs.RSVPPer =
          (
            ((myThurs.RSVP + myThurs.Wait + myThurs.Web) * 100) /
            myThurs.Quantity
          ).toFixed(2) + "%";
        myThurs.RSVPNoWebPer =
          (((myThurs.RSVP + myThurs.Wait) * 100) / myThurs.Quantity).toFixed(
            2
          ) + "%";
      }
      if (myFri.Quantity > 0) {
        myFri.RSVPPer =
          (
            ((myFri.RSVP + myFri.Wait + myFri.Web) * 100) /
            myFri.Quantity
          ).toFixed(2) + "%";
        myFri.RSVPNoWebPer =
          (((myFri.RSVP + myFri.Wait) * 100) / myFri.Quantity).toFixed(2) + "%";
      }
      if (mySat.Quantity > 0) {
        mySat.RSVPPer =
          (
            ((mySat.RSVP + mySat.Wait + mySat.Web) * 100) /
            mySat.Quantity
          ).toFixed(2) + "%";
        mySat.RSVPNoWebPer =
          (((mySat.RSVP + mySat.Wait) * 100) / mySat.Quantity).toFixed(2) + "%";
      }
      if (mySun.Quantity > 0) {
        mySun.RSVPPer =
          (
            ((mySun.RSVP + mySun.Wait + mySun.Web) * 100) /
            mySun.Quantity
          ).toFixed(2) + "%";
        mySun.RSVPNoWebPer =
          (((mySun.RSVP + mySun.Wait) * 100) / mySun.Quantity).toFixed(2) + "%";
      }
      this.calculatedStats.push(myMon);
      this.calculatedStats.push(myTues);
      this.calculatedStats.push(myWed);
      this.calculatedStats.push(myThurs);
      this.calculatedStats.push(myFri);
      this.calculatedStats.push(mySat);
      this.calculatedStats.push(mySun);
      myTotals.SeatingCount =
        myMon.SeatingCount +
        myTues.SeatingCount +
        myWed.SeatingCount +
        myThurs.SeatingCount +
        myFri.SeatingCount +
        mySat.SeatingCount +
        mySun.SeatingCount;
      myTotals.SeminarCount =
        myMon.SeminarCount +
        myTues.SeminarCount +
        myWed.SeminarCount +
        myThurs.SeminarCount +
        myFri.SeminarCount +
        mySat.SeminarCount +
        mySun.SeminarCount;
      myTotals.Quantity =
        myMon.Quantity +
        myTues.Quantity +
        myWed.Quantity +
        myThurs.Quantity +
        myFri.Quantity +
        mySat.Quantity +
        mySun.Quantity;
      myTotals.RSVP =
        myMon.RSVP +
        myTues.RSVP +
        myWed.RSVP +
        myThurs.RSVP +
        myFri.RSVP +
        mySat.RSVP +
        mySun.RSVP;
      myTotals.Wait =
        myMon.Wait +
        myTues.Wait +
        myWed.Wait +
        myThurs.Wait +
        myFri.Wait +
        mySat.Wait +
        mySun.Wait;
      myTotals.Web =
        myMon.Web +
        myTues.Web +
        myWed.Web +
        myThurs.Web +
        myFri.Web +
        mySat.Web +
        mySun.Web;

      if (myTotals.Quantity > 0) {
        myTotals.RSVPPer =
          (
            ((myTotals.RSVP + myTotals.Wait + myTotals.Web) * 100) /
            myTotals.Quantity
          ).toFixed(2) + "%";
        myTotals.RSVPNoWebPer =
          (((myTotals.RSVP + myTotals.Wait) * 100) / myTotals.Quantity).toFixed(
            2
          ) + "%";
      }
      this.calculatedStats.push(myTotals);
    },
    filterList: function() {
      this.filteredObjects = this.$store.state.seminar.rsvp_comparators;
      // .filter(
      //   comp =>
      //     (comp.Seminar.Owner.UserProfileID ===
      //       this.$store.state.globals.default_pp ||
      //       !this.$store.state.globals.default_pp) &&
      //     new Date(comp.Seating.DateOfSeating) >=
      //       new Date(this.$store.state.globals.default_dates.from_date) &&
      //     new Date(comp.Seating.DateOfSeating) <=
      //       new Date(this.$store.state.globals.default_dates.to_date) &&
      //     (comp.Seminar.Territory.TerritoryID ===
      //       this.$store.state.globals.default_report_territory ||
      //       !this.$store.state.globals.default_report_territory)
      //        &&
      //     // (comp.Seminar.Vendor.VendorID ===
      //     //   this.$store.state.globals.default_report_vendor ||
      //     //   !this.$store.state.globals.default_report_vendor) &&
      //     (comp.Seminar.Artwork1.MailerType.MailerTypeID ===
      //       this.$store.state.globals.default_report_mailer ||
      //       comp.Seminar.Artwork2.MailerType.MailerTypeID ===
      //         this.$store.state.globals.default_report_mailer ||
      //       !this.$store.state.globals.default_report_mailer) &&
      //     (comp.Seminar.Artwork1ID ===
      //       this.$store.state.globals.default_report_artwork ||
      //       comp.Seminar.Artwork2ID ===
      //         this.$store.state.globals.default_report_artwork ||
      //       !this.$store.state.globals.default_report_artwork)

      // .filter(
      //   (seminar) =>
      //     seminar.Territory.TerritoryName.toLowerCase().indexOf(
      //       this.searchString.toLowerCase()
      //     ) > -1 ||
      //     seminar.Seatings[0].Restaurant.Name.toLowerCase().indexOf(
      //       this.searchString.toLowerCase()
      //     ) > -1 ||
      //     seminar.Owner.UserName.toLowerCase().indexOf(
      //       this.searchString.toLowerCase()
      //     ) > -1 ||
      //     seminar.EventType.EventTypeName.toLowerCase().indexOf(
      //       this.searchString.toLowerCase()
      //     ) > -1
      //);
      this.isGenerating = false;
    },
    myRowClickHandler(record, index) {
      this.$store
        .dispatch("seminar/loadSeminarEdit", record.SeminarID)
        .then(() => {
          this.$router.push({ name: "Seminar" });
        });
    }
  }
};
</script>

<style lang="scss" scoped></style>
